"use client";

import type { FC } from "react";
import { useMemo } from "react";
import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { EditableProfileWrapper } from "./EditableProfileWrapper";
import { DeleteAccountForm } from "./forms/DeleteAccountForm";

export const deleteAccountProfileWrapper = "delete-account-profile-wrapper";
export const EditableProfileDeleteAccount: FC = () => {
    const { getMultiple } = useMicrocopy();
    const namedMC = {
        title: CommonCMS.profile.deleteAccountTitle,
        edit: CommonCMS.edit,
        editAria: CommonCMS.profile.deleteAccountButtonAria,
    };

    const microcopies = useMemo(() => {
        return getMultiple(CommonCMS.page, Object.values(namedMC));
    }, []);

    return (
        <EditableProfileWrapper
            title={microcopies[namedMC.title]}
            headers={{
                editButton: microcopies[namedMC.edit],
                editButtonAria: microcopies[namedMC.editAria],
            }}
            data={[]}
            data-testid={deleteAccountProfileWrapper}
        >
            <DeleteAccountForm />
        </EditableProfileWrapper>
    );
};

export default EditableProfileDeleteAccount;
